module.exports = __webpack_public_path__ + "images/exago-banner-left.png";